export function fullscreenElementOrBody() {
  return document.fullscreenElement instanceof HTMLElement
    ? document.fullscreenElement
    : document.body;
}
